import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
export function StickyCTA() {
  return <div className="fixed bottom-0 left-0 right-0 bg-teal-600 shadow-lg z-40 py-4 px-4" data-id="element-135">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4" data-id="element-136">
        <span className="text-white font-semibold hidden sm:block" data-id="element-137">
          Need urgent appliance repair?
        </span>
        <div className="flex gap-3 w-full sm:w-auto" data-id="element-138">
          <a href="tel:08000554969" className="flex-1 sm:flex-none bg-white text-teal-700 px-6 py-3 rounded-lg font-semibold hover:bg-teal-50 transition flex items-center justify-center gap-2" data-id="element-139">
            <PhoneIcon className="w-4 h-4" data-id="element-140" />
            Call Now
          </a>
          <Link to="/contact" className="flex-1 sm:flex-none border-2 border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-teal-700 transition text-center" data-id="element-141">
            Request a Callout
          </Link>
        </div>
      </div>
    </div>;
}